module.exports = __webpack_public_path__ + "img/reference-provinzenz.18540c1f.webp";